jQuery(document).ready(function () {

    var footerMenus = jQuery('a.footer-nav-item');
    
    var htmlSelector = document.querySelector('html');    

    footerMenus.on('click', function (evt) {
        evt.preventDefault();

        ga('send', 'event', 'Menu Bar', 'tap', jQuery(this).data('title'));
        
        // If menu button was clicked
        if (jQuery(this).data('title') === 'menu') {
            var mobileNavMenu = document.querySelector('#mobile-main-nav');
            
            // If the menu is already open
            if (jQuery('html').hasClass('mm-wrapper_opened')) {
                jQuery(this).parent().removeClass('menu-open');
                jQuery(this).removeClass('is-active');
            }
            
            // If the menu is closed
            else {
                jQuery(this).parent().addClass('menu-open');
                jQuery(this).addClass('is-active');
            }

            if ( mobileNavMenu.classList.contains('mobile-menu-active') ) {
              mobileNavMenu.classList.remove('mobile-menu-active');
              htmlSelector.classList.remove('mm-wrapper_blocking');
            } else {
              mobileNavMenu.classList.add('mobile-menu-active');
              htmlSelector.classList.add('mm-wrapper_blocking');
            }

        } else {
            jQuery(this).toggleClass('is-active');
            window.location = jQuery(this).attr('href');
            return false;
        }
    });
});